import { ACCEPTING_ORDER_ID, BECOME_BRAND_ID, BRAND_POLICIES_ID, CANCELING_AN_ORDER_ID, CONTACTING_MY_RETAILER_ID, CONTACT_A_BRAND_ID, DISPUTE_A_RETAILER_COMPLAINT_ID, EU_DSA_ID, FAIRE_ACCOUNT_SECURITY_ID, FAIRE_COST_ID, HOW_AM_I_NOTIFIED_NEW_ORDERS_ID, HOW_DO_NET_60_TERMS_WORK_ID, HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCTS_ID, ISSUE_WITH_MY_ORDER_PAYOUT_ID, MAKE_A_RETURN_ID, NAM_SELL_ON_FAIRE_ID, NON_NAM_SELL_ON_FAIRE_ID, ORDER_INVOICE_ID, ORDER_STATUS_ID, PAYOUT_AUSTRALIAN_ID, PAYOUT_CALCULATED_ID, PAYOUT_CANADIAN_ID, PAYOUT_EUROPEAN_ID, REPORT_DAMAGED_MISSING_ID, RETAILER_WHAT_IS_FAIRE_ID, SETTING_UP_PAYOUT_ID, TAX_FORM_1099_ID, TROUBLESHOOTING_WITH_ADYEN_ID, WHERE_IS_FAIRE_AVAILABLE_ID, WORD_FROM_CEO_ID } from "@faire/help-center-utils/articleIds";
import { Article } from "@faire/help-center-utils/articles";
import { useStrictLocalization } from "@faire/web/common/localization";
export var useArticles = function useArticles() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = {
    GettingStarted: {
      COMPLETING_ONBOARDING_FORM: new Article({
        name: strictLocalize({
          id: "C6NF6S",
          defaultMessage: [{
            "type": 0,
            "value": "Mijn registratieformulier invullen"
          }]
        }),
        id: "360039212391"
      }),
      UPLOAD_FIRST_CATALOG: new Article({
        name: strictLocalize({
          id: "AlDz2c",
          defaultMessage: [{
            "type": 0,
            "value": "Je productcatalogus uploaden"
          }]
        }),
        id: "4416016600347"
      }),
      RESELLER_ID: new Article({
        name: strictLocalize({
          id: "POZmQR",
          defaultMessage: [{
            "type": 0,
            "value": "Heb ik een reseller-ID nodig?"
          }]
        }),
        id: "360016203651"
      }),
      BRICK_AND_MORTAR: new Article({
        name: strictLocalize({
          id: "HlhWGa",
          defaultMessage: [{
            "type": 0,
            "value": "Wat als ik geen fysieke winkel heb?"
          }]
        }),
        id: "360016111231"
      }),
      WORD_FROM_CEO: new Article({
        name: strictLocalize({
          id: "p2eAyI",
          defaultMessage: [{
            "type": 0,
            "value": "Een woord van onze CEO"
          }]
        }),
        id: WORD_FROM_CEO_ID
      }),
      OPEN_WITH_FAIRE: new Article({
        name: strictLocalize({
          id: "kG9smm",
          defaultMessage: [{
            "type": 0,
            "value": "Open with Faire"
          }]
        }),
        id: "4645924980763"
      })
    },
    MyOrders: {
      HOW_AM_I_NOTIFIED_NEW_ORDERS: new Article({
        name: strictLocalize({
          id: "DDqsse",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe word ik op de hoogte gehouden van nieuwe bestellingen?"
          }]
        }),
        id: HOW_AM_I_NOTIFIED_NEW_ORDERS_ID
      }),
      HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCT: new Article({
        name: strictLocalize({
          id: "FLONHc",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe moet ik mijn Faire-producten verkopen?"
          }]
        }),
        id: HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCTS_ID
      }),
      BUSINESS_PROFILE: new Article({
        name: strictLocalize({
          id: "uNwAAN",
          defaultMessage: [{
            "type": 0,
            "value": "Welke informatie is er nodig voor mijn winkelprofiel?"
          }]
        }),
        id: "360035578692"
      }),
      SYNC_SQUARE_POS: new Article({
        name: strictLocalize({
          id: "CuRF0T",
          defaultMessage: [{
            "type": 0,
            "value": "Mijn kassasysteem integreren met Faire"
          }]
        }),
        id: "360037248712"
      }),
      FAIRE_PROTECTION: new Article({
        name: strictLocalize({
          id: "ymeN0d",
          defaultMessage: [{
            "type": 0,
            "value": "Wat is Faire-beveiliging?"
          }]
        }),
        id: "360016111511"
      }),
      REPORT_DAMAGED_MISSING: new Article({
        name: strictLocalize({
          id: "v9kPYq",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe meld ik beschadigde of ontbrekende artikelen?"
          }]
        }),
        id: REPORT_DAMAGED_MISSING_ID
      }),
      ORDER_STATUS: new Article({
        name: strictLocalize({
          id: "t0xr1I",
          defaultMessage: [{
            "type": 0,
            "value": "Wanneer krijg ik mijn bestellingen?"
          }]
        }),
        id: ORDER_STATUS_ID
      }),
      ORDER_RETURNED_TO_SENDER: new Article({
        name: strictLocalize({
          id: "9S0FTQ",
          defaultMessage: [{
            "type": 0,
            "value": "Bestelling teruggestuurd naar afzender"
          }]
        }),
        id: "26594585812891"
      }),
      ORDER_QUESTIONS: new Article({
        name: strictLocalize({
          id: "9LqEo1",
          defaultMessage: [{
            "type": 0,
            "value": "Vragen over een artikel"
          }]
        }),
        id: "360006953111"
      }),
      BRAND_MINIMUMS: new Article({
        name: strictLocalize({
          id: "w5vD/I",
          defaultMessage: [{
            "type": 0,
            "value": "Wat zijn bestelminima"
          }]
        }),
        id: "360016302912"
      }),
      CANCELING_AN_ORDER: new Article({
        name: strictLocalize({
          id: "0VnS38",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe kan ik een bestelling annuleren?"
          }]
        }),
        id: CANCELING_AN_ORDER_ID
      }),
      CONTACT_A_BRAND: new Article({
        name: strictLocalize({
          id: "SjOF+W",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe kan ik contact opnemen met een merk op Faire?"
          }]
        }),
        id: CONTACT_A_BRAND_ID
      })
    },
    ManageMyShop: {
      ADD_EDIT_PRODUCTS: new Article({
        name: strictLocalize({
          id: "9Rgpw6",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe kan ik producten toevoegen of bewerken?"
          }]
        }),
        id: "360006829831"
      }),
      BRAND_PROMOTION_CALCULATED: new Article({
        name: strictLocalize({
          id: "/rgb2v",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe worden promoties berekend?"
          }]
        }),
        id: "360032489472"
      }),
      CUSTOMIZE_MY_PRODUCT_TRANSLATIONS: new Article({
        name: strictLocalize({
          id: "5p35uh",
          defaultMessage: [{
            "type": 0,
            "value": "Kan ik mijn productvertalingen aanpassen?"
          }]
        }),
        id: "7652446722331"
      }),
      CURRENCY_SPECIFIC_PRICING: new Article({
        name: strictLocalize({
          id: "W+2iJv",
          defaultMessage: [{
            "type": 0,
            "value": "Valutaspecifieke prijzen"
          }]
        }),
        id: "360055558732"
      }),
      SETTING_PRODUCT_INVENTORY_LEVELS: new Article({
        name: strictLocalize({
          id: "2saxOG",
          defaultMessage: [{
            "type": 0,
            "value": "Mijn productvoorraadniveaus instellen"
          }]
        }),
        id: "360045187791"
      }),
      ARRANGE_MY_SHOP_LISTINGS: new Article({
        name: strictLocalize({
          id: "kspgKw",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe beheer ik de productpagina's van mijn winkel?"
          }]
        }),
        id: "360039477271"
      }),
      WHAT_IS_EXCLUSIVITY_PROGRAM: new Article({
        name: strictLocalize({
          id: "Ddnv4m",
          defaultMessage: [{
            "type": 0,
            "value": "Wat is het exclusiviteitsprogramma?"
          }]
        }),
        id: "18543447335451"
      })
    },
    Referrals: {
      CAN_I_REFER_BRANDS_TO_FAIRE: new Article({
        name: strictLocalize({
          id: "TG9PtX",
          defaultMessage: [{
            "type": 0,
            "value": "Kan ik merken doorverwijzen naar Faire?"
          }]
        }),
        id: "4404937922587"
      }),
      USE_REFERRAL_PROMOTION: new Article({
        name: strictLocalize({
          id: "FJ+m6x",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe kan ik een doorverwijzingspromotie van een merk gebruiken?"
          }]
        }),
        id: "360034300092"
      })
    },
    OptimizingMyPage: {
      COVER_IMAGE_GUIDELINES: new Article({
        name: strictLocalize({
          id: "fXnXFB",
          defaultMessage: [{
            "type": 0,
            "value": "Richtlijnen voor omslagfoto's"
          }]
        }),
        id: "360016791851"
      }),
      PRODUCT_PHOTOGRAPHY_GUIDELINES: new Article({
        name: strictLocalize({
          id: "YINiMH",
          defaultMessage: [{
            "type": 0,
            "value": "Richtlijnen voor productfoto's"
          }]
        }),
        id: "360016568092"
      }),
      IMAGE_SIZE_REQUIREMENTS: new Article({
        name: strictLocalize({
          id: "lXeU3d",
          defaultMessage: [{
            "type": 0,
            "value": "Vereisten voor afbeeldingsgrootte"
          }]
        }),
        id: "360032130371"
      }),
      BRAND_STORY_GUIDELINES: new Article({
        name: strictLocalize({
          id: "d3h1Ep",
          defaultMessage: [{
            "type": 0,
            "value": "Richtlijnen voor merkverhalen"
          }]
        }),
        id: "360026756912"
      }),
      ADD_VIDEO: new Article({
        name: strictLocalize({
          id: "LJd4Gb",
          defaultMessage: [{
            "type": 0,
            "value": "Kan ik een video toevoegen aan mijn winkel?"
          }]
        }),
        id: "360054846452"
      })
    },
    InvoicesAndBilling: {
      RECEIVE_ORDER_INVOICE: new Article({
        name: strictLocalize({
          id: "X9dXUE",
          defaultMessage: [{
            "type": 0,
            "value": "Krijg ik een factuur van mijn bestelling?"
          }]
        }),
        id: "4408351766171"
      }),
      PRODUCT_REPORT: new Article({
        name: strictLocalize({
          id: "DE+DLf",
          defaultMessage: [{
            "type": 0,
            "value": "Wat als een retailer mijn producten als vermist of beschadigd meldt?"
          }]
        }),
        id: "360033568051"
      }),
      PAYOUT_CALCULATED: new Article({
        name: strictLocalize({
          id: "eE3x7A",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe wordt mijn uitbetaling berekend?"
          }]
        }),
        id: PAYOUT_CALCULATED_ID
      }),
      PAYOUT_EUROPEAN: new Article({
        name: strictLocalize({
          id: "OiNzBj",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe stel ik uitbetalingen naar een Europese bankrekening in?"
          }]
        }),
        id: PAYOUT_EUROPEAN_ID
      }),
      PAYOUT_AUSTRALIAN: new Article({
        name: strictLocalize({
          id: "NsyCP6",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe stel ik uitbetalingen naar een Australische bankrekening in?"
          }]
        }),
        id: PAYOUT_AUSTRALIAN_ID
      }),
      PAYOUT_CANADIAN: new Article({
        name: strictLocalize({
          id: "M1uK1z",
          defaultMessage: [{
            "type": 0,
            "value": "Uitbetalingen voor Canadese merken"
          }]
        }),
        id: PAYOUT_CANADIAN_ID
      }),
      ISSUE_WITH_MY_ORDER_PAYOUT: new Article({
        name: strictLocalize({
          id: "GeTSEg",
          defaultMessage: [{
            "type": 0,
            "value": "Probleem met de uitbetaling van de bestelling"
          }]
        }),
        id: ISSUE_WITH_MY_ORDER_PAYOUT_ID
      }),
      TAX_FORM_1099: new Article({
        name: strictLocalize({
          id: "P/vdrr",
          defaultMessage: [{
            "type": 0,
            "value": "Ontvang ik een 1099-K belastingformulier?"
          }]
        }),
        id: TAX_FORM_1099_ID
      }),
      SETTING_UP_PAYOUT: new Article({
        name: strictLocalize({
          id: "qkrW6t",
          defaultMessage: [{
            "type": 0,
            "value": "Je uitbetalingsaccount instellen"
          }]
        }),
        id: SETTING_UP_PAYOUT_ID
      }),
      TROUBLESHOOTING_WITH_ADYEN: new Article({
        name: strictLocalize({
          id: "ipXayn",
          defaultMessage: [{
            "type": 0,
            "value": "Problemen met Adyen oplossen"
          }]
        }),
        id: TROUBLESHOOTING_WITH_ADYEN_ID
      }),
      PAYOUT_ISSUE: new Article({
        name: strictLocalize({
          id: "GeTSEg",
          defaultMessage: [{
            "type": 0,
            "value": "Probleem met de uitbetaling van de bestelling"
          }]
        }),
        id: "360006915532"
      }),
      TAX_INFORMATION: new Article({
        name: strictLocalize({
          id: "/xy/gD",
          defaultMessage: [{
            "type": 0,
            "value": "Belastinggegevens instellen"
          }]
        }),
        id: "360038950092"
      }),
      NAM_SELL_ON_FAIRE: new Article({
        name: strictLocalize({
          id: "ztJJ3l",
          defaultMessage: [{
            "type": 0,
            "value": "Wat kost het om op Faire te verkopen als ik in Noord-Amerika ben gevestigd?"
          }]
        }),
        id: NAM_SELL_ON_FAIRE_ID
      }),
      NON_NAM_SELL_ON_FAIRE: new Article({
        name: strictLocalize({
          id: "0wp1lr",
          defaultMessage: [{
            "type": 0,
            "value": "Wat kost het om op Faire te verkopen als ik buiten Noord-Amerika ben gevestigd?"
          }]
        }),
        id: NON_NAM_SELL_ON_FAIRE_ID
      })
    },
    Account: {
      ORDER_ISSUE: new Article({
        name: strictLocalize({
          id: "CuhRSF",
          defaultMessage: [{
            "type": 0,
            "value": "Waarom kan ik de bestelling van mijn retailer niet in mijn account zien?"
          }]
        }),
        id: "4415920212123"
      }),
      CANNOT_FIND_ORDER_NUMBER: new Article({
        name: strictLocalize({
          id: "BBAJ+h",
          defaultMessage: [{
            "type": 0,
            "value": "Waarom kan ik het bestelnummer van een retailer niet vinden?"
          }]
        }),
        id: "4402385627163"
      }),
      NOT_OPEN: new Article({
        name: strictLocalize({
          id: "nWFeyz",
          defaultMessage: [{
            "type": 0,
            "value": "We zijn nog niet open. Kan ik nog bestellen?"
          }]
        }),
        id: "360016111571"
      }),
      ACCOUNT_EMAIL: new Article({
        name: strictLocalize({
          id: "yV7GVR",
          defaultMessage: [{
            "type": 0,
            "value": "Mijn e-mailadres voor inloggen wijzigen"
          }]
        }),
        id: "360016302272"
      }),
      MANAGE_TEAMS: new Article({
        name: strictLocalize({
          id: "Z1h57J",
          defaultMessage: [{
            "type": 0,
            "value": "Stel je team samen op Faire"
          }]
        }),
        id: "8675579278619"
      }),
      EMAIL_NOTIFICATIONS: new Article({
        name: strictLocalize({
          id: "Xbq6xK",
          defaultMessage: [{
            "type": 0,
            "value": "Kan ik me afmelden voor specifieke e-mails van Faire?"
          }]
        }),
        id: "360059197351"
      }),
      EMAIL_PREFERENCES: new Article({
        name: strictLocalize({
          id: "o547a2",
          defaultMessage: [{
            "type": 0,
            "value": "Mijn e-mailvoorkeuren instellen"
          }]
        }),
        id: "360057278792"
      }),
      RESETTING_PASSWORD: new Article({
        name: strictLocalize({
          id: "3o8L8n",
          defaultMessage: [{
            "type": 0,
            "value": "Mijn wachtwoord opnieuw instellen"
          }]
        }),
        id: "360019610312"
      }),
      WHAT_IS_EXCLUSIVITY: new Article({
        name: strictLocalize({
          id: "x+S067",
          defaultMessage: [{
            "type": 0,
            "value": "Wat is exclusiviteit?"
          }]
        }),
        id: "19903209185947"
      })
    },
    FaireDirect: {
      ORDER_COMMISSION: new Article({
        name: strictLocalize({
          id: "s4fd/u",
          defaultMessage: [{
            "type": 0,
            "value": "Mijn Direct-bestelling heeft commissie, wat is er gebeurd?"
          }]
        }),
        id: "360031800672"
      }),
      ZERO_COMMISSION: new Article({
        name: strictLocalize({
          id: "GTHgGi",
          defaultMessage: [{
            "type": 0,
            "value": "Faire Direct-beleid voor 0% commissie"
          }]
        }),
        id: "360031800672"
      }),
      EMAIL_CAMPAIGN: new Article({
        name: strictLocalize({
          id: "4SUKRT",
          defaultMessage: [{
            "type": 0,
            "value": "Wat is een e-mailcampagne?"
          }]
        }),
        id: "360038731612"
      }),
      EMAIL_AUTOMATIONS: new Article({
        name: strictLocalize({
          id: "YvFUHb",
          defaultMessage: [{
            "type": 0,
            "value": "Wat zijn e-mailautomatiseringen?"
          }]
        }),
        id: "360034668751"
      }),
      FAIRE_DIRECT: new Article({
        name: strictLocalize({
          id: "zTqoXs",
          defaultMessage: [{
            "type": 0,
            "value": "Wat is Faire Direct?"
          }]
        }),
        id: "360032132391"
      }),
      FD_ELIGIBLE: new Article({
        name: strictLocalize({
          id: "zbXaBM",
          defaultMessage: [{
            "type": 0,
            "value": "Wie komt in aanmerking om via Faire Direct te bestellen?"
          }]
        }),
        id: "360032149291"
      }),
      FD_LINK: new Article({
        name: "How do I use my Direct Link?",
        id: "360032133351"
      })
    },
    FulfillingOrders: {
      SPLIT_ATS_ORDER: new Article({
        name: strictLocalize({
          id: "7DQaFp",
          defaultMessage: [{
            "type": 0,
            "value": "Een ATS-bestelling opsplitsen"
          }]
        }),
        id: "360060488431"
      }),
      SPLIT_PREORDER: new Article({
        name: strictLocalize({
          id: "5Pei21",
          defaultMessage: [{
            "type": 0,
            "value": "Een voorbestelling opsplitsen"
          }]
        }),
        id: "360060414111"
      }),
      ACCEPTING_ORDER: new Article({
        name: strictLocalize({
          id: "osVMG8",
          defaultMessage: [{
            "type": 0,
            "value": "Een bestelling accepteren"
          }]
        }),
        id: ACCEPTING_ORDER_ID
      }),
      COMMERCIAL_INVOICE: new Article({
        name: strictLocalize({
          id: "WCJyt7",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe maak ik een handelsfactuur aan?"
          }]
        }),
        id: "4404314652059"
      }),
      FULFILLING_ORDER: new Article({
        name: strictLocalize({
          id: "hE2Nbm",
          defaultMessage: [{
            "type": 0,
            "value": "Ik kan een bestelling niet uitvoeren"
          }]
        }),
        id: "360007184831"
      }),
      UNDERSTAND_ORDER_STATUS: new Article({
        name: strictLocalize({
          id: "5R1ZVj",
          defaultMessage: [{
            "type": 0,
            "value": "De status van je bestelling begrijpen"
          }]
        }),
        id: ORDER_INVOICE_ID
      }),
      CAN_RETAILER_CANCEL_ORDER: new Article({
        name: strictLocalize({
          id: "0UcJaN",
          defaultMessage: [{
            "type": 0,
            "value": "Kan een retailer bestellingen annuleren?"
          }]
        }),
        id: "360023102031"
      }),
      SHIPPING_ORDER: new Article({
        name: strictLocalize({
          id: "LTM3/z",
          defaultMessage: [{
            "type": 0,
            "value": "Een bestelling verzenden"
          }]
        }),
        id: "360023300451"
      }),
      SETTING_OUT_OF_STOCK: new Article({
        name: strictLocalize({
          id: "kEJsXY",
          defaultMessage: [{
            "type": 0,
            "value": "Artikelen die niet op voorraad of niet meer leverbaar zijn instellen"
          }]
        }),
        id: "360006911352"
      }),
      SHIP_WITH_FAIRE: new Article({
        name: strictLocalize({
          id: "72y5ni",
          defaultMessage: [{
            "type": 0,
            "value": "Verzenden via Faire"
          }]
        }),
        id: "360030933131"
      }),
      LABEL_ISSUES: new Article({
        name: strictLocalize({
          id: "oBNgYb",
          defaultMessage: [{
            "type": 0,
            "value": "Waarom krijg ik een foutmelding bij het gebruik van Verzenden via Faire"
          }]
        }),
        id: "360040920571"
      }),
      SHIP_ON_YOUR_OWN: new Article({
        name: strictLocalize({
          id: "IlfctE",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe 'Zelf verzenden' werkt"
          }]
        }),
        id: "360030933311"
      }),
      SHIPPING_COSTS: new Article({
        name: strictLocalize({
          id: "SPzcuL",
          defaultMessage: [{
            "type": 0,
            "value": "Verzendkosten naar andere landen beheren"
          }]
        }),
        id: "360040349352"
      }),
      SHIPPING_WORK: new Article({
        name: strictLocalize({
          id: "ybSoRd",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe werkt de verzending?"
          }]
        }),
        id: "4405859125531"
      }),
      ABOUT_SHIPPING: new Article({
        name: strictLocalize({
          id: "1JAZ0s",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe werkt verzending?"
          }]
        }),
        id: "360016111831"
      }),
      SHIPPING_ADDRESS: new Article({
        name: strictLocalize({
          id: "NAicKW",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe wijzig ik mijn verzendadres"
          }]
        }),
        id: "360018235292"
      }),
      CHANGE_SHIPPING_ADDRESS: new Article({
        name: strictLocalize({
          id: "v3+vuS",
          defaultMessage: [{
            "type": 0,
            "value": "Kan ik mijn adres wijzigen nadat een bestelling is verzonden?"
          }]
        }),
        id: "360007197951"
      }),
      EDIT_RETAILER_ORDER: new Article({
        name: strictLocalize({
          id: "ArjSpz",
          defaultMessage: [{
            "type": 0,
            "value": "Kan ik de bestelling van een retailer bewerken?"
          }]
        }),
        id: "360053212551"
      })
    },
    ReturnsAndRefunds: {
      MAKE_A_RETURN: new Article({
        name: strictLocalize({
          id: "PTuRfO",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe dien ik een retouraanvraag in?"
          }]
        }),
        id: MAKE_A_RETURN_ID
      }),
      EXTEND_A_RETURN: new Article({
        name: strictLocalize({
          id: "hDezWS",
          defaultMessage: [{
            "type": 0,
            "value": "Kan ik mijn retourperiode verlengen?"
          }]
        }),
        id: "360022876131"
      }),
      CANT_RETURN: new Article({
        name: strictLocalize({
          id: "F85fJa",
          defaultMessage: [{
            "type": 0,
            "value": "Waarom kan ik mijn artikelen niet retourneren?"
          }]
        }),
        id: "360007069352"
      })
    },
    PaymentsAndInvoices: {
      CHANGE_MY_PAYMENT_METHOD: new Article({
        name: strictLocalize({
          id: "sRWcLE",
          defaultMessage: [{
            "type": 0,
            "value": "Mijn betaalmethode wijzigen"
          }]
        }),
        id: "360018497831"
      }),
      NET_60_TERMS: new Article({
        name: strictLocalize({
          id: "17QDXy",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe werkt de 60 dagen netto betalingstermijn?"
          }]
        }),
        id: HOW_DO_NET_60_TERMS_WORK_ID
      }),
      PAY_INVOICES: new Article({
        name: strictLocalize({
          id: "+8Ngr8",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe betaal ik mijn facturen?"
          }]
        }),
        id: "360006920172"
      }),
      INVOICE_DUE: new Article({
        name: strictLocalize({
          id: "r9dmpJ",
          defaultMessage: [{
            "type": 0,
            "value": "Wat is de uiterste betaaldatum van mijn factuur?"
          }]
        }),
        id: "360006994232"
      }),
      UNDERSTANDING_ORDER_INVOICE: new Article({
        name: strictLocalize({
          id: "COn3iE",
          defaultMessage: [{
            "type": 0,
            "value": "De bestelfactuur begrijpen"
          }]
        }),
        id: "4416125712795"
      }),
      HOW_DO_I_PAY_FOR_ORDERS: new Article({
        name: strictLocalize({
          id: "1k8YBm",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe betaal ik voor mijn bestellingen?"
          }]
        }),
        id: "360015892632"
      }),
      HOW_DO_I_CHANGE_MY_BILLING_ADDRESS: new Article({
        name: strictLocalize({
          id: "jdoE1a",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe wijzig ik mijn factuuradres?"
          }]
        }),
        id: "24430827309467"
      })
    },
    INSIDER: {
      INSIDER_BRAND_PARTNERSHIP: new Article({
        name: strictLocalize({
          id: "H8tXRk",
          defaultMessage: [{
            "type": 0,
            "value": "Het Insider Partner-programma voor merken"
          }]
        }),
        id: "25213101060123"
      })
    },
    FAQ: {
      RESETTING_PASSWORD: new Article({
        name: strictLocalize({
          id: "3o8L8n",
          defaultMessage: [{
            "type": 0,
            "value": "Mijn wachtwoord opnieuw instellen"
          }]
        }),
        id: "360019854651"
      }),
      RETAILER_WHAT_IS_FAIRE: new Article({
        name: strictLocalize({
          id: "lDcCOD",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe begin ik met inkopen op Faire?"
          }]
        }),
        id: RETAILER_WHAT_IS_FAIRE_ID
      }),
      EU_DSA: new Article({
        name: strictLocalize({
          id: "bdi6Mi",
          defaultMessage: [{
            "type": 0,
            "value": "Centraal aanspreekpunt voor Europese Digital Services Act"
          }]
        }),
        id: EU_DSA_ID
      }),
      HOW_RETURNS_WORK: new Article({
        name: strictLocalize({
          id: "3+R7cy",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe werkt retourneren"
          }]
        }),
        id: "360015892592"
      }),
      FAIRE_INSIDER_US: new Article({
        name: strictLocalize({
          id: "zPGP9w",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe werkt Insider voor Amerikaanse retailers?"
          }]
        }),
        id: "4406840862747"
      }),
      FAIRE_INSIDER_EU: new Article({
        name: strictLocalize({
          id: "Ua9ksa",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe werkt Insider voor Europese retailers?"
          }]
        }),
        id: "4418050425115"
      }),
      WHERE_IS_FAIRE_AVAILABLE: new Article({
        name: strictLocalize({
          id: "m68Icb",
          defaultMessage: [{
            "type": 0,
            "value": "Waar is Faire beschikbaar?"
          }]
        }),
        id: WHERE_IS_FAIRE_AVAILABLE_ID
      }),
      BRAND_REFERRAL_PROGRAM_TERMS_CONDITIONS: new Article({
        name: strictLocalize({
          id: "rAW53+",
          defaultMessage: [{
            "type": 0,
            "value": "ALGEMENE VOORWAARDEN VAN HET DOORVERWIJZINGSPROGRAMMA VOOR MERKEN VAN FAIRE"
          }]
        }),
        id: "13628687993371"
      }),
      FAIRE_ACCOUNT_SECURITY: new Article({
        name: strictLocalize({
          id: "evS1O1",
          defaultMessage: [{
            "type": 0,
            "value": "Best practices voor accountbeveiliging op Faire"
          }]
        }),
        id: FAIRE_ACCOUNT_SECURITY_ID
      })
    },
    FAQForProspectiveBrands: {
      HOW_GET_PAID: new Article({
        name: strictLocalize({
          id: "LYRxSA",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe krijg ik uitbetaald?"
          }]
        }),
        id: "360015893272"
      }),
      FAIRE_COST: new Article({
        name: strictLocalize({
          id: "36qrix",
          defaultMessage: [{
            "type": 0,
            "value": "Wat kost het om op Faire te verkopen?"
          }]
        }),
        id: FAIRE_COST_ID
      }),
      BECOME_BRAND: new Article({
        name: strictLocalize({
          id: "ICLZE5",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe verkoop ik op Faire?"
          }]
        }),
        id: BECOME_BRAND_ID
      })
    },
    International: {
      VAT_WORK_NON_EU_ORDERS: new Article({
        name: strictLocalize({
          id: "XXZP7G",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe werkt de btw voor Europese bestellingen buiten de EU?"
          }]
        }),
        id: "4404431808155"
      }),
      PAY_VAT_NON_EU: new Article({
        name: strictLocalize({
          id: "MIkkag",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe betaal ik btw over mijn bestellingen in Europese landen buiten de EU?"
          }]
        }),
        id: "4404431878683"
      }),
      VAT_WORK_EU_ORDERS: new Article({
        name: strictLocalize({
          id: "ox+alG",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe werkt de btw voor bestellingen uit de EU?"
          }]
        }),
        id: "360057747911"
      }),
      CANADIAN_RETAILERS: new Article({
        name: strictLocalize({
          id: "2l9kFh",
          defaultMessage: [{
            "type": 0,
            "value": "Aan de slag als Canadese retailer"
          }]
        }),
        id: "360034894292"
      }),
      LOCATION_SHOP_LIVE: new Article({
        name: strictLocalize({
          id: "/BK1wq",
          defaultMessage: [{
            "type": 0,
            "value": "Kan ik kiezen in welke landen en regio’s mijn winkel live is?"
          }]
        }),
        id: "360016524391"
      }),
      SELLING: new Article({
        name: strictLocalize({
          id: "vR2146",
          defaultMessage: [{
            "type": 0,
            "value": "Een gids voor internationaal verkopen op Faire"
          }]
        }),
        id: "4407511671579"
      }),
      BUY: new Article({
        name: strictLocalize({
          id: "MAingx",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe werkt internationaal inkopen op Faire"
          }]
        }),
        id: "4405345083675"
      })
    },
    ContactMyRetailer: {
      CONTACTING_MY_RETAILER: new Article({
        name: strictLocalize({
          id: "53rQbV",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe neem ik contact op met mijn retailers op Faire?"
          }]
        }),
        id: CONTACTING_MY_RETAILER_ID
      })
    },
    BrandTermsAndPolicies: {
      DISPUTE_A_RETAILER_COMPLAINT: new Article({
        name: strictLocalize({
          id: "vFNhSP",
          defaultMessage: [{
            "type": 0,
            "value": "Een klacht van een retailer betwisten"
          }]
        }),
        id: DISPUTE_A_RETAILER_COMPLAINT_ID
      }),
      BRAND_POLICIES: new Article({
        name: strictLocalize({
          id: "lLVQEM",
          defaultMessage: [{
            "type": 0,
            "value": "Merkbeleid"
          }]
        }),
        id: BRAND_POLICIES_ID
      })
    },
    ImportFeesAndDuties: {
      DUTIES_REFUND: new Article({
        name: strictLocalize({
          id: "cgQGPC",
          defaultMessage: [{
            "type": 0,
            "value": "Wat gebeurt er als Faire mijn invoerrechten betaalt?"
          }]
        }),
        id: "4403349101723"
      }),
      USA: new Article({
        name: strictLocalize({
          id: "lc7vKv",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe werkt verzending naar de VS?"
          }]
        }),
        id: "360031133351"
      }),
      Canada: new Article({
        name: strictLocalize({
          id: "zsTBx4",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe werkt verzending naar Canada?"
          }]
        }),
        id: "360057607832"
      }),
      Europe: new Article({
        name: strictLocalize({
          id: "XLscSH",
          defaultMessage: [{
            "type": 0,
            "value": "Importeren naar Europa"
          }]
        }),
        id: "360056061932"
      }),
      Australia: new Article({
        name: strictLocalize({
          id: "PXuWXh",
          defaultMessage: [{
            "type": 0,
            "value": "Importeren naar Australië"
          }]
        }),
        id: "6668590967579"
      }),
      EORI: new Article({
        name: strictLocalize({
          id: "93QqWi",
          defaultMessage: [{
            "type": 0,
            "value": "Hoe vraag ik een EORI-nummer aan?"
          }]
        }),
        id: "4409464460187"
      }),
      VAT: new Article({
        name: strictLocalize({
          id: "KVID5a",
          defaultMessage: [{
            "type": 0,
            "value": "Heb ik een btw-nummer nodig?"
          }]
        }),
        id: "4405333889435"
      })
    },
    Integration: {
      SOFTWARE_INTEGRATION_WITH_FAIRE: new Article({
        name: strictLocalize({
          id: "M/W49R",
          defaultMessage: [{
            "type": 0,
            "value": "Software-integratie met Faire"
          }]
        }),
        id: "360037964391"
      }),
      ONBOARDING_WITH_SHOPIFY: new Article({
        name: strictLocalize({
          id: "SDYcWM",
          defaultMessage: [{
            "type": 0,
            "value": "Onboarding met Shopify"
          }]
        }),
        id: "4407533398939"
      }),
      CAN_I_INTEGRATE_WITH_SHOPIFY: new Article({
        name: strictLocalize({
          id: "rkM/49",
          defaultMessage: [{
            "type": 0,
            "value": "Kan ik integreren met Shopify?"
          }]
        }),
        id: "360054245292"
      })
    }
  };
  return articles;
};